(() => {
  const qs = (s, c = document) => c.querySelector(s);
  const qsa = (s, c = document) => [...c.querySelectorAll(s)];

  const intro = qs('[data-storm-intro]');
  if (intro) {
    const dismiss = () => {
      intro.classList.add('is-gone');
      document.body.classList.remove('intro-active');
      try { sessionStorage.setItem('bc-intro-seen-v11', '1'); } catch (_) {}
      window.setTimeout(() => intro.remove(), 900);
    };
    let seen = false;
    try { seen = sessionStorage.getItem('bc-intro-seen-v11') === '1'; } catch (_) {}
    if (seen || matchMedia('(prefers-reduced-motion: reduce)').matches) intro.remove();
    else {
      const mobileLite = matchMedia('(max-width: 700px), (pointer: coarse)').matches;
      intro.classList.toggle('is-mobile-lite', mobileLite);
      document.body.classList.add('intro-active');
      requestAnimationFrame(() => intro.classList.add('is-running'));
      qs('[data-intro-skip]', intro)?.addEventListener('click', dismiss);
      window.setTimeout(dismiss, mobileLite ? 5600 : 7200);
    }
  }

  const header = qs('[data-header]');
  const syncHeader = () => header?.classList.toggle('is-scrolled', scrollY > 18);
  syncHeader(); addEventListener('scroll', syncHeader, { passive: true });

  const menuButton = qs('[data-menu-toggle]');
  const mobileNav = qs('[data-mobile-nav]');
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded', String(open));
    mobileNav.hidden = !open;
    document.body.classList.toggle('menu-open', open);
  });

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } });
  }, { threshold: .12 });
  qsa('.reveal').forEach(el => observer.observe(el));

  const cartShell = qs('[data-cart-shell]');
  let cartReturnFocus = null;
  const openCart = () => { if (!cartShell) return; cartReturnFocus = document.activeElement; cartShell.hidden = false; requestAnimationFrame(() => { cartShell.classList.add('is-open'); qs('[data-cart-close]', cartShell)?.focus(); }); document.body.classList.add('drawer-open'); };
  const closeCart = () => { if (!cartShell) return; cartShell.classList.remove('is-open'); document.body.classList.remove('drawer-open'); setTimeout(() => { cartShell.hidden = true; cartReturnFocus?.focus?.(); }, 350); };
  qsa('[data-cart-open]').forEach(b => b.addEventListener('click', openCart));
  qsa('[data-cart-close]').forEach(b => b.addEventListener('click', closeCart));
  addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  const productForm = qs('.product-form');
  productForm?.addEventListener('submit', async e => {
    e.preventDefault();
    const button = qs('[type="submit"]', productForm);
    button.disabled = true; button.textContent = 'ADDING…';
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(productForm) });
      if (!response.ok) throw new Error('Unable to add item');
      const cart = await fetch('/cart.js').then(r => r.json());
      qsa('[data-cart-count]').forEach(el => el.textContent = `(${cart.item_count})`);
      const cartBody = qs('[data-cart-body]');
      cartBody.classList.remove('cart-drawer__empty');
      cartBody.innerHTML = `<p>${cart.item_count} item${cart.item_count === 1 ? '' : 's'} carrying with you.</p><p class="cart-total">${new Intl.NumberFormat('en-US',{style:'currency',currency:cart.currency || 'USD'}).format(cart.total_price / 100)}</p>`;
      openCart();
    } catch (error) { button.textContent = error.message.toUpperCase(); }
    finally { setTimeout(() => { button.disabled = false; button.textContent = 'ADD TO BAG'; }, 1200); }
  });

  const hero = qs('[data-parallax]');
  if (hero && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    hero.addEventListener('pointermove', e => {
      const x = (e.clientX / innerWidth - .5) * 14;
      const y = (e.clientY / innerHeight - .5) * 10;
      hero.style.setProperty('--mx', `${x}px`); hero.style.setProperty('--my', `${y}px`);
    });
  }
})();
